import React from "react";
import SectionBlock from "../../../../global/components/FeatureCard/SectionBlock";
import mobileManagement from "../../../../assets/images/mobileLink/mobile-management.png";
import userManagement from "../../../../assets/images/mobileLink/user-management.png";

const PAGE_X = "px-6 lg:px-[120px]";

const sections = [
  {
    image: mobileManagement,
    label: "Mobile Management",
    description:
      "Today's customers want to manage their systems via a mobile device. Mobile Manager provides secure access to the user's system from anywhere. Our panel and mobile interconnect using SSL to a cloud app server where your smart device connects and interlinks. The App is capable of managing multiple sites, viewing of the system logs, video event tags, door management such as locking and unlocking with live view of video.",
    imageLeft: true,
    imageBg: "#f8f8f8",
    textBg: "#f8f8f8",
    textAlign: "left",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "550px",
    sectionHeight: "540px",
  },
  {
    image: userManagement,
    description:
      "User management allows the administrator the ability to add and edit users and credentials in the system. Threat level management allows the user to provide lockdown management or cause event actions that allow the administrator to manage their facilities. Mobile App access and capabilities are based on user role permissions. A user on mobile is the same as a user logged into the system; audit reports keep track of all modifications by user. Simple and Secure Mobility!",
    imageLeft: false,
    imageBg: "#ffffff",
    textBg: "#ffffff",
    textAlign: "right",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "552px",
    sectionHeight: "540px",
  },
];

export const MobileLinkContent = () => (
  <div className="bg-white w-full">
    <section
      className={`bg-white flex flex-col items-center justify-center gap-6 ${PAGE_X} pt-28 sm:pt-24 min-h-[258px] text-center`}
    >
      <h1 className="text-black text-[32px] font-medium font-['Inter'] leading-normal max-w-[1004px]">
        Mobile Security Management
      </h1>
      <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal max-w-[872px]">
        Securely monitor, control, and manage access systems from anywhere with
        real-time mobile administration, live video visibility, and role-based
        security control.
      </p>
    </section>

    <div className="w-full bg-white mt-6">
      {sections.map((section, index) => (
        <SectionBlock
          key={section.label ?? `section-${index}`}
          {...section}
        />
      ))}
    </div>
  </div>
);

export default MobileLinkContent;
